import React, {useCallback} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {BottomCTA} from 'components/Accommodation/Offers/BottomCTA'
import {RoundShareButton} from 'components/Accommodation/ShareButton'
import {
  ShareComponent,
  ShareType
} from 'components/Accommodation/ShareButton/constants'
import {getIsRtlLanguage} from 'modules/meta/selectors'
import {getLightboxOverlay} from 'modules/overlay/selectors'
import {hideOverlay} from 'modules/overlay/slice'
import {getSearchBoxValues} from 'modules/searchBox/selectors'
import {imageProvider} from 'utils/imageProvider'

import {useDispatchTeamEvent} from '@daedalus/core/src/analytics/components/TeamContext'
import {trackEvent} from '@daedalus/core/src/analytics/modules/actions'
import {
  Action,
  Category,
  Entity,
  Team
} from '@daedalus/core/src/analytics/types/Events'
import {LightboxGalleryMobile} from '@daedalus/shared/src/accommodation/LightboxGalleryMobile'

interface Props {
  component: string
}

export const LightboxGalleryWithOffer = ({component}: Props) => {
  const dispatch = useDispatch()
  const dispatchTeamEvent = useDispatchTeamEvent()
  const isRtl = useSelector(getIsRtlLanguage)
  const overlay = useSelector(getLightboxOverlay)
  const {initialImageIndex, hotelId, images} = overlay || {}
  const {checkIn, checkOut, rooms} = useSelector(getSearchBoxValues)
  const shareUrlParams = {
    hotelId,
    checkIn,
    checkOut,
    rooms,
    component: ShareComponent.FullScreenImageGallery
  }

  const hideLightboxOverlay = useCallback(() => {
    dispatch(hideOverlay())
  }, [dispatch])

  const trackOverlaySwipe = useCallback(() => {
    dispatchTeamEvent(
      trackEvent({
        category: Category.User,
        entity: Entity.FullScreenImageGallery,
        action: Action.Scrolled
      })
    )
  }, [dispatchTeamEvent])

  const trackZoomedEvent = useCallback(() => {
    dispatch(
      trackEvent({
        category: Category.User,
        entity: Entity.FullScreenImageGallery,
        action: Action.Zoomed,
        team: Team.Select
      })
    )
  }, [dispatch])

  return (
    <LightboxGalleryMobile
      isOpen={!!overlay}
      isRtl={isRtl}
      images={images}
      initialImageIndex={initialImageIndex}
      imageProvider={imageProvider}
      rightHeaderButtonSlot={
        <RoundShareButton
          shareParams={shareUrlParams}
          component={ShareComponent.FullScreenImageGallery}
          shareType={ShareType.ShareLink}
        />
      }
      footerSlot={<BottomCTA hotelId={hotelId} sourceComponent={component} />}
      onSwipe={trackOverlaySwipe}
      onZoom={trackZoomedEvent}
      onClose={hideLightboxOverlay}
    />
  )
}

export default LightboxGalleryWithOffer
